'use client';

import { vars } from '@repo/config';
import * as React from 'react';

type LinkStatusType = 'choose' | 'linking' | 'success' | 'error';

interface IUseLinkOauthResult {
  status: LinkStatusType;
  errorMessage: string;
}

export function useLinkOauth(token: string | null, step: string | null): IUseLinkOauthResult {
  const [status, setStatus] = React.useState<LinkStatusType>(
    step === 'complete' ? 'linking' : 'choose',
  );
  const [errorMessage, setErrorMessage] = React.useState('');

  React.useEffect(() => {
    if (step !== 'complete' || !token) {
      return;
    }

    const linkAccount = async (): Promise<void> => {
      const res = await fetch(`${vars.url.identityUrl}/telegram/link-oauth`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ telegramSessionToken: token }),
        credentials: 'include',
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error((body as { detail?: string }).detail || 'Linking failed');
      }
    };

    linkAccount()
      .then(() => setStatus('success'))
      .catch((err: Error) => {
        setErrorMessage(err.message);
        setStatus('error');
      });
  }, [step, token]);

  return { status, errorMessage };
}
